import { Header } from "@/components/layout/header";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="flex-1">
        <main className="py-6">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-semibold text-gray-900 font-serif">Terms of Service</h1>
              <p className="mt-2 text-gray-500">Effective Date: 4/24/2025</p>
            </div>

            <div className="prose prose-slate max-w-none mx-auto">
              <p className="lead">
                PreVisly is a service provided by EdenTech LLC, a Pennsylvania-based company. By accessing or using the PreVisly.com website or any related services, you agree to be bound by these Terms of Service.
              </p>

              <h2>1. Use of Service</h2>
              <p>
                You may use PreVisly to upload screenplays and generate AI-based media, including images, audio, and video. You confirm that you own or have the right to use any content you upload. You are solely responsible for any material submitted through your account.
              </p>

              <h2>2. Accounts</h2>
              <p>
                You agree to provide accurate, complete information when creating an account. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account.
              </p>

              <h2>3. Payments</h2>
              <p>
                Some features of PreVisly require payment. All transactions are securely processed via third-party providers such as Stripe. By completing a purchase, you agree to the payment processor’s terms and authorize us to charge your selected payment method.
              </p>

              <h2>4. Content Rights</h2>
              <p>
                You retain ownership of all screenplays and user-submitted content, as well as the media generated through PreVisly. You grant EdenTech LLC a non-exclusive, worldwide license to use, process, and store this content as necessary to operate and improve our services. If you choose to publicly share your project via the showcase, you grant us the right to display and promote it publicly.
              </p>

              <h2>5. AI-Generated Content Disclosure</h2>
              <p>
                Media created using PreVisly is generated by third-party artificial intelligence models. All outputs are considered AI-generated and may include visible or embedded disclosures or watermarks. You agree to maintain or preserve such disclosures if you share generated media externally.
              </p>

              <h2>6. Content Moderation</h2>
              <p>
                PreVisly uses third-party moderation tools to analyze and review input before rendering AI content. If your submission is flagged for violating usage guidelines, rendering may be delayed or blocked. You will be notified if such action is taken and may revise your input accordingly.
              </p>

              <h2>7. Acceptable Use</h2>
              <p>
                You agree not to upload, generate, or distribute content that is illegal, infringes on third-party rights, includes unauthorized likenesses, or misleads others about its origin. We reserve the right to remove content or suspend accounts that violate this policy.
              </p>

              <h2>8. Copyright & DMCA Policy</h2>
              <p>
                We comply with the Digital Millennium Copyright Act (DMCA). If you believe your work has been used in violation of copyright law, you may submit a takedown request to our designated DMCA agent. Repeat infringers may have their accounts permanently disabled.
              </p>

              <h2>9. Public Showcase</h2>
              <p>
                Users may choose to publish their generated content to the PreVisly public showcase. By doing so, you grant EdenTech LLC a license to display, promote, and share that content publicly. Only content you explicitly submit for public sharing will be included in the showcase.
              </p>

              <h2>10. Content Hosting</h2>
              <p>
                We host generated content for up to one year for non-subscribers. Active paid subscribers receive indefinite hosting for as long as their subscription remains active. We reserve the right to remove hosted content for expired or inactive accounts after the one-year period. It is your responsibility to back up content you wish to retain.
              </p>

              <h2>11. Points Policy</h2>
              <p>
                PreVisly operates on a points-based system. Points can be purchased at retail price or at a discounted rate with an active subscription. Subscription upgrades are charged the difference for the remaining period. Downgrades take effect the next billing cycle. Cancellations are immediate. Purchased points remain available even after changes to subscription status.
              </p>
              <p>
                Refunds may be issued only on a case-by-case basis and only if the points have not been used to create any media. Once points are used, they are not refundable.
              </p>
              <p>
                Current rates (subject to change): 100 points per screenplay page (up to 200 words), 10 points per on-demand image, 40 points per page for edited video re-rendering. See our Pricing Page for the most current rates.
              </p>

              <h2>12. File Access and Security Disclosure</h2>
              <p>
                All files are stored using randomly generated, unguessable file paths and are publicly accessible via direct URLs to enable playback and editing. If you share a file URL or your session is compromised, others may access your files. You are responsible for maintaining session and device security.
              </p>

              <h2>13. Termination</h2>
              <p>
                We may suspend or terminate your account at any time for violations of these terms or for any reason at our sole discretion. You may cancel your account at any time.
              </p>

              <h2>14. Dispute Resolution</h2>
              <p>
                You agree to resolve any dispute arising from these terms or your use of the PreVisly service through binding arbitration, rather than in court, except for eligible claims in small claims court. Arbitration will be conducted under the American Arbitration Association (AAA) rules in Pennsylvania, unless both parties agree otherwise. You waive your right to a jury trial and to participate in any class action.
              </p>

              <h2>15. Governing Law</h2>
              <p>
                These terms are governed by the laws of the Commonwealth of Pennsylvania, without regard to conflict-of-law principles.
              </p>

              <h2>16. Electronic Communications</h2>
              <p>
                By using PreVisly, you consent to receive communications from us electronically. This includes account notices, legal updates, and transactional messages. You agree these communications satisfy any legal requirement that they be in writing.
              </p>

              <h2>17. Modifications</h2>
              <p>
                We may update these Terms of Service at any time. Material changes will be announced via email or platform notification. Continued use of PreVisly after such changes constitutes acceptance of the updated terms.
              </p>

              <h2>18. Contact</h2>
              <p>
                If you have any questions, contact us at <a href="mailto:jon@edentech.com">jon@edentech.com</a>.
              </p>

              <p>© 2025 EdenTech LLC. All rights reserved.</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
